var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import React from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
const OperationButton = (_a) => {
    var { onClick, requiredKey, activeAccount, setErrorMessage } = _a, buttonProps = __rest(_a, ["onClick", "requiredKey", "activeAccount", "setErrorMessage"]);
    const handleClick = () => {
        if (requiredKey && !activeAccount.keys[requiredKey]) {
            setErrorMessage('popup_missing_key', [
                getMessage(requiredKey),
            ]);
        }
        else {
            onClick();
        }
    };
    return React.createElement(ButtonComponent, Object.assign({}, buttonProps, { onClick: handleClick }));
};
const mapStateToProps = (state) => {
    return { activeAccount: state.steem.activeAccount };
};
const connector = connect(mapStateToProps, { setErrorMessage });
export const OperationButtonComponent = connector(OperationButton);
